import { render } from "./ProductSubthree.vue?vue&type=template&id=4fef9ab7&scoped=true"
import script from "./ProductSubthree.vue?vue&type=script&lang=js"
export * from "./ProductSubthree.vue?vue&type=script&lang=js"

import "./ProductSubthree.vue?vue&type=style&index=0&id=4fef9ab7&scoped=true&lang=css"
import "./ProductSubthree.vue?vue&type=style&index=1&id=4fef9ab7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fef9ab7"]])

export default __exports__